import 'babel-polyfill'
import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import history from './history';
import './react-table-defaults';
import './styles/index.css';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { routes } from './fuse-configs/fuseRoutesConfig';
import { FuseLayout, FuseTheme, FuseAuthorization } from '@fuse';
import MainToolbar from './main/MainToolbar';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import MainFooter from './main/MainFooter';
import jssExtend from 'jss-extend'
import QuickPanel from 'main/quickPanel/QuickPanel';
import FirebaseAuth from 'firebase-db/FirebaseAuth';
import store from 'store';
import { ReactTableDefaults } from 'react-table';
import { only_allow_chrome } from 'config';
 
// Sets ReactTable Default minRow
Object.assign(ReactTableDefaults, {
    minRows: 0,
});
 
const jss = create({
    ...jssPreset(),
    plugins: [...jssPreset().plugins, jssExtend()]
});
 
jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();
 
var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
let isFirefox = /Firefox/.test(navigator.userAgent); //Mozilla Firefox: E-002
let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor); //Safari: E-002
let isEdge = /Edge/.test(navigator.userAgent); //Microsoft Edge: E-002
let isIE = /Trident/.test(navigator.userAgent); //Internet Explorer (IE): E-002
var isOpera = /OPR/.test(navigator.userAgent); //Opera: E-002
// console.log(isChrome, only_allow_chrome)
// console.log(!isChrome && only_allow_chrome)
 
if (!isChrome && only_allow_chrome && !isFirefox && !isSafari && !isEdge && !isIE && !isOpera) { // E-002
    // console.log('here')
    ReactDOM.render(
      <div style={{ height: "100%", width: "100%", backgroundColor: "white" }}>
        <div
          style={{
            margin: "auto",
            width: "50%",
            textAlign: "center",
            marginTop: "100px",
            border: "2px solid darkblue",
            padding: "10px",
            backgroundColor: "white",
          }}
        >
          <div>Browser incompatible, please use Chrome</div>
          <div>
            <a href="https://www.google.com/chrome/">Download Chrome Here</a>
          </div>
        </div>
      </div>,
      document.getElementById("root")
    );
}
 
else {
    ReactDOM.render(
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <Provider store={store}>
                <FirebaseAuth>
                    <Router history={history}>
                        <FuseAuthorization routes={routes}>
                            <FuseTheme>
                                <FuseLayout
                                    routes={routes}
                                    toolbar={
                                        <MainToolbar />
                                    }
                                    navbarHeader={
                                        <MainNavbarHeader />
                                    }
                                    navbarContent={
                                        <MainNavbarContent />
                                    }
                                    footer={
                                        <MainFooter />
                                    }
                                    rightSidePanel={
                                        <QuickPanel />
                                    }
                                >
                                </FuseLayout>
                            </FuseTheme>
                        </FuseAuthorization>
                    </Router>
                </FirebaseAuth>
            </Provider>
        </JssProvider>
        , document.getElementById('root'));
}
 
registerServiceWorker();


// WEBPACK FOOTER //
// src/index.js